import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CustomerGroupsValidator } from '@symphony-solo/domain/customer-groups/src';
import { ModifiersValidator } from '@symphony-solo/domain/modifiers/src';
import { PaymentsValidator } from '@symphony-solo/domain/payments/src';
import { PriceLevelsValidator } from '@symphony-solo/domain/price-levels/src';
import { TaxRateShiftsValidator } from '@symphony-solo/domain/taxrate-shifts/src';
import { TaxrateValidator } from '@symphony-solo/domain/taxrates/src';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { CUSTOMER_GROUPS, LOCATION_SELECTION_TABS } from '@symphony-solo/shared/utils/src';
import { of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { SyncDataService } from '../services';
import { SyncDataValidator } from '../validator';
import { syncronizeAllDataAction, syncronizeAllDataErrorAction, syncronizeAllDataSuccessAction } from './sync-data.actions';

@Injectable()
export class SyncDataEffects {
  constructor(private actions$: Actions, private syncDataService: SyncDataService, private navController: NavController) {}

  protected syncronizeAllData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(syncronizeAllDataAction),
      switchMap(() => {
        return this.syncDataService.getData().pipe(
          switchMap(([customerGroups, taxrateShifts, taxrates, payments, modifiers, priceLevels]) => {
            const actions = new SyncDataValidator()
              .addValidator(new CustomerGroupsValidator(customerGroups.data))
              .addValidator(new TaxRateShiftsValidator(taxrateShifts.data))
              .addValidator(new TaxrateValidator(taxrates.data))
              .addValidator(new PaymentsValidator(payments.data))
              .addValidator(new ModifiersValidator(modifiers.data))
              .addValidator(new PriceLevelsValidator(priceLevels.data))
              .validate();
            actions.push(syncronizeAllDataSuccessAction());
            return actions;
          }),
          catchError((failure: AppStateFailure) => {
            return of(syncronizeAllDataErrorAction({ failure }));
          })
        );
      })
    );
  });

  protected syncronizeAllDataSuccess$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(syncronizeAllDataSuccessAction),
        tap(() => {
          this.navController.navigateRoot(CUSTOMER_GROUPS);
        })
      );
    },
    { dispatch: false }
  );

  protected syncronizeAllDataError$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(syncronizeAllDataErrorAction),
        tap(() => {
          this.navController.navigateRoot(LOCATION_SELECTION_TABS);
        })
      );
    },
    { dispatch: false }
  );
}
